var _mask, _rect, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_7314_96111",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.625,
    y: 13.5,
    width: 8,
    height: 8,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.625,
    y: 13.5,
    width: 8,
    height: 8,
    rx: 1,
    stroke: "#FFA443",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_7314_96111)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.625,
    cy: 17.5,
    r: 3.25,
    stroke: "#FFA443",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4085 4.375C12.5047 4.20833 12.7453 4.20833 12.8415 4.375L16.3056 10.375C16.4018 10.5417 16.2816 10.75 16.0891 10.75H9.1609C8.96845 10.75 8.84817 10.5417 8.94439 10.375L12.4085 4.375Z",
    stroke: "#FFA443",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderProfile);
export default __webpack_public_path__ + "static/media/orderProfile.2366bfd46f360468f58f6fe206266b9c.svg";
export { ForwardRef as ReactComponent };